import React, { useEffect, useMemo, useState } from "react";
import { Collapse, Icon } from "antd";

import JobSwmsV3EmergencyPlanDetailsSection from "./fixed/JobSwmsV3EmergencyPlanDetailsSection";
import JobSwmsV3EmergencyPlanDocumentAuthorizationSection from "./fixed/JobSwmsV3EmergencyPlanDocumentAuthorizationSection";
import JobSwmsV3EmergencyPlanReorderableSection from "./reorderable/JobSwmsV3EmergencyPlanReorderableSection";
import { EMERGENCY_PLAN_SUPPORTED_SECTION_KEYS } from "../../../../../../SwmsMasters/EmergencyPlans/sections/registry/EmergencyPlanSectionRegistry.config";

export default function JobSwmsV3EmergencyPlanSectionRegistry({
  planIndex,
  categories,
  documentNumber,
  swmsStatus,
  swmsData,
  loading,
  selectedPlan,
  methodItemTypeGroups = [],
  methodItemTypesLoading = false
}) {
  const documentAuthorizationData = swmsData
    && swmsData.sections
    && swmsData.sections.document_authorization
    && swmsData.sections.document_authorization.data
    ? swmsData.sections.document_authorization.data
    : {};
  const availableSections = selectedPlan && selectedPlan.sections && typeof selectedPlan.sections === "object"
    ? selectedPlan.sections
    : {};
  const sourceOrder = selectedPlan && Array.isArray(selectedPlan.section_order)
    ? selectedPlan.section_order
    : Object.keys(availableSections);
  const computedSectionOrder = useMemo(
    () => sourceOrder.filter((key) => EMERGENCY_PLAN_SUPPORTED_SECTION_KEYS[key] && availableSections[key]),
    [sourceOrder.join("|"), availableSections]
  );
  const [sectionOrder, setSectionOrder] = useState(computedSectionOrder);
  const [draggingSectionKey, setDraggingSectionKey] = useState(null);

  useEffect(() => {
    setSectionOrder(computedSectionOrder);
  }, [computedSectionOrder.join("|")]);

  const moveSection = (sourceKey, targetKey) => {
    if (!sourceKey || !targetKey || sourceKey === targetKey) {
      return;
    }

    setSectionOrder((currentOrder) => {
      const sourceIndex = currentOrder.indexOf(sourceKey);
      const targetIndex = currentOrder.indexOf(targetKey);
      if (sourceIndex < 0 || targetIndex < 0) {
        return currentOrder;
      }

      const nextOrder = [...currentOrder];
      const [moved] = nextOrder.splice(sourceIndex, 1);
      nextOrder.splice(targetIndex, 0, moved);
      return nextOrder;
    });
  };

  return (
    <Collapse
      accordion
      defaultActiveKey="emergency-plan-details"
      bordered={false}
      expandIconPosition="right"
      className="custom-section-v2-collapse custom-job-swms-collapse swms-masters-action-collapse"
      expandIcon={({ isActive }) => (
        <Icon
          type="caret-right"
          rotate={isActive ? 90 : 0}
          style={{ color: "#2f1f41" }}
        />
      )}
    >
      {JobSwmsV3EmergencyPlanDetailsSection({
        planIndex,
        categories,
        documentNumber,
        swmsStatus,
        swmsData,
        loading
      })}
      {JobSwmsV3EmergencyPlanDocumentAuthorizationSection({
        planIndex,
        loading,
        approvers: Array.isArray(documentAuthorizationData.approvers)
          ? documentAuthorizationData.approvers
          : []
      })}
      {sectionOrder.map((sectionKey) => JobSwmsV3EmergencyPlanReorderableSection({
        sectionKey,
        section: availableSections[sectionKey],
        planIndex,
        procedures: selectedPlan && Array.isArray(selectedPlan.procedures) ? selectedPlan.procedures : [],
        loading,
        methodItemTypeGroups,
        methodItemTypesLoading,
        onDragStart: (event) => {
          setDraggingSectionKey(sectionKey);
          if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("text/plain", sectionKey);
          }
        },
        onDragEnd: () => setDraggingSectionKey(null),
        onDragEnter: () => {
          if (draggingSectionKey && draggingSectionKey !== sectionKey) {
            moveSection(draggingSectionKey, sectionKey);
          }
        },
        onDragOver: (event) => {
          if (draggingSectionKey && draggingSectionKey !== sectionKey) {
            event.preventDefault();
          }
        }
      }))}
    </Collapse>
  );
}
